import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AdminBulkMowerImport from "@/pages/admin/AdminBulkMowerImport";

export const Route = createFileRoute("/admin/lawn-mowers/bulk-import")({
  component: () => (
    <ProtectedRoute>
      <AdminBulkMowerImport />
    </ProtectedRoute>
  ),
});
